/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostPluginVersionQuery,
  PostPluginVersionBody,
  GetPluginVersionResponse,
  PostPluginVersionResponse,
} from '../types';

export class Plugin extends Controller {
  async getPluginVersion<T extends GetPluginVersionResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/plugin/version',
      axiosConfig
    );
  }

  async postPluginVersion<
    T extends PostPluginVersionResponse,
    D,
    C extends PostPluginVersionBody
  >(
    body: C,
    query: PostPluginVersionQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/plugin/version', query),
      body,
      axiosConfig
    );
  }
}
